$(window).load(function() {
  var window_width = $(window).width();
  if(window_width < 1025){
  } else {
    ajaxCart.load();
  }
});

$('.AddToCart_btn_cls').click(function(evt) {
  evt.preventDefault();
  var formclass = $(this).parents('form').attr('id');
  var form = $('#'+formclass);
  if(form.hasClass('discount_form')){
    var qty = $('input[name="quantity"]', form).val();
    var title = qty + "+";
    if(qty >= $('#product-select option:last').val()){
      $('#product-select option:last').prop('selected', true);
    }
    $('#product-select option[data-title="' + title + '"]').prop('selected', true);
  }
  ShopifyAPI.addItemFromForm('#'+formclass);
  return false;
});


var main_div_id = $(".cart_hover_btn_cls");
$(main_div_id).mouseover(function(){
  $(this).find(".cart_hover_code").show();
});
$(main_div_id).mouseout(function(){
  $(this).find(".cart_hover_code").hide();
});

jQuery('.bg_img').each(function() {

  var el = $(this),
      src = el.attr('src'),
      parent = el.parent();
  //height = el.height();	

  parent.css({
    'background-image': 'url(' + src + ')',
    'background-size': 'cover',
    'background-position': 'center'
    //'height':height 
  });

  el.hide();
});


var windowWidth = $(window).width();
if(windowWidth <= 800){

  $(window).scroll(function(){
    var sticky = $('.sticky'),
        scroll = $(window).scrollTop();

    if (scroll > 0) { sticky.addClass('fixed');}
    else {sticky.removeClass('fixed');}
  });
}


$(document).ready(function(e) {
  $('.parallax-window').jarallax({
    speed: 0.1,
    /* imgWidth: 1920,
         imgHeight: 1190*/
  });

});


function equalizer(){
  var max = -1;
  $(".product-wrap .title").css('min-height', 'auto'); 
  $('.product-wrap .title').each(function() {

    var minHeight = $(this).innerHeight();
    max = minHeight > max ? minHeight : max;

  });  
  //console.log(max);
  $(".product-wrap .title").css('min-height',max); 
}

jQuery(window).load(function() {
  equalizer();
});

jQuery(window).resize(function() {
  equalizer();
});

/*
$(".mobile_nav").on("click", function(){
  
  $('body').toggleClass('is-active');
  $(this).find('div').toggleClass('open');
  $('.dropdown_container').toggle();
  
  console.log('click');
  
});
*/